<template>
  <v-row dense>
    <v-row dense>

      <!-- Filtro promociones -->
      <v-col cols="2">
        <div @click="mostrarPopupPromociones()" >
          <v-autocomplete :no-data-text="$t('sinDatos')"
              v-model="promocion" id="promocion"
              :items="promociones"
              :label="localizationFiltros.promocion"
              item-value="id"
              item-text="name"
              :disabled="disabled"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
        </div>
      </v-col>

      <!-- Filtro proveedores -->
      <v-col cols="2">
        <v-autocomplete 
          :no-data-text="$t('sinDatos')" 
          v-if="promocion.length === 0 && (!oficio || oficio == null || oficio == '')" 
          v-model="proveedor" id="proveedor" 
          :label="localizationFiltros.proveedor"
          :items="sortItemsByField(providers, 'name')" 
          item-text="name" 
          item-value="id"
          clearable 
          multiple
          :disabled="disabled" />

        <v-autocomplete 
          :no-data-text="$t('sinDatos')" 
          v-else v-model="proveedor" id="proveedor" 
          :label="localizationFiltros.proveedor"
          :items="sortItemsByField(providersByPromoAndProf, 'name')" 
          item-text="name" 
          item-value="id"
          clearable 
          multiple
          :disabled="disabled" />
      </v-col>

      <!-- Filtro Oficio -->
      <v-col cols="2">
        <v-autocomplete 
          :no-data-text="$t('sinDatos')" 
          v-model="oficio" id="oficio" 
          :label="localizationFiltros.oficio"
          :items="sortItemsByField(oficios, 'name')" 
          :item-text="mostrarIdioma" 
          item-value="id" 
          clearable
          multiple
          :disabled="disabled" />
      </v-col>

      <!-- Filtro Estado -->
      <v-col cols="2">
        <v-autocomplete 
          :no-data-text="$t('sinDatos')" 
          v-model="estado" id="estado" 
          :label="localizationFiltros.estado"
          :items="estados" 
          :item-text="mostrarIdioma" 
          item-value="id"
          clearable 
          multiple
          :disabled="disabled">
        </v-autocomplete>
      </v-col>

      <!-- Filtro Responsable -->
      <v-col cols="2">
        <v-autocomplete :no-data-text="$t('sinDatos')" 
          v-model="responsable" id="responsable" 
          :items="responsables"
          :label="$t('sectionInformes.filtros.responsables')"
          item-text="name"
          item-value="id"
          :disabled="disabled"
          multiple
          clearable
        />
      </v-col>

      <!-- Filtro Tipo Documento -->
      <v-col cols="2">
        <v-autocomplete :no-data-text="$t('sinDatos')" 
          v-model="tipoDocumento" id="responsable" 
          :items="tiposDocumento"
          :label="$t('sectionInformes.filtros.tipoDocumento')"
          item-text="name"
          item-value="id"
          :disabled="disabled"
          multiple
          clearable
        />
      </v-col>

      <!-- Filtro Fecha Desde -->
      <v-col cols="2">
        <o-date-picker v-model="fechaDesde" id="fechaDesde" :label="localizationFiltros.desde"
          :disabled="disabled" :max="fechaHasta" />
      </v-col>

      <!-- Filtro Fecha Hasta -->
      <v-col cols="2">
        <o-date-picker v-model="fechaHasta" id="fechaHasta" :label="localizationFiltros.hasta"
          :disabled="disabled" :min="fechaDesde" />
      </v-col>

      <!-- Filtro Cliente no conforme -->
      <v-col cols="2">
        <v-checkbox v-model="revisada" id="revisada" :label="localizationFiltros.revisada" color="primary"></v-checkbox>
      </v-col>

      <v-col cols="3"/>

      <v-col cols="12" align="end">
        <v-row justify="space-between">
          <v-col cols="6">
            
            <!-- Botón Borrar Filtros -->
            <v-btn-toggle v-model="toggle" id="toggle" @change="untoggle">
              <v-btn active-class="none" style="opacity: 1"
                :disabled="disabled" @click="borrarFiltros">
                {{localizationFiltros.borrar}}
              </v-btn>
              <!-- Botón Aplicar Filtros -->
              <v-btn active-class="none" style="opacity: 1; margin-left: 10px"
                :disabled="disabled" @click="aplicarFiltros" color="primary">
                {{localizationFiltros.aplicar}}
              </v-btn>
            </v-btn-toggle>
            </v-col>

        </v-row>
      </v-col>
    </v-row>

    <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromociones
          :multiple="true"
          @selected="popupSeleccionarPromociones($event)"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'

export default {
  components: {
    PopUpSeleccionarPromociones
  },
  props: {
    tipo: {
      type: String,
      default: 'informeSoporteDocumental'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggle: null,
      promocion: [],
      mostrarSeleccionarPromociones: false,
      fechaDesde: null,
      fechaHasta: null,
      storeFilters: null,
      proveedor: [],
      oficio: [],
      estado: this.$store.state.incidencias.estadosFiltroInicial,
      responsable: [],
      revisada: false,
      tipoDocumento: [],
      tiposDocumento: [
        { id: 1, name: 'Fotos de apertura' },
        { id: 2, name: 'Fotos de cierre' },
        { id: 3, name: 'Documentación solicitud' },
        { id: 4, name: 'Documentación visita' }
      ],
    }
  },
  created () {
    this.loadConfiguracion()
    this.getResponsables()
  },
  computed: {
    ...mapGetters({
      promocionesIdubapi: 'incidencias/getPromocionesIdubapi',
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localizationFiltros () {
      return this.$t('sectionInformes.filtros')
    },
    objFiltrosParaApi () {
      return {
        promociones: this.promocion,
        proveedores: this.proveedor,
        oficios: this.oficio,
        estados: this.estado,
        responsables: this.responsable,
        tiposDocumento: this.tipoDocumento,
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        revisada: this.revisada ? 1 : 0
      }
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones
      }
      return []
    },
    providers () {
      if (this.$store.state.incidencias.providers) {
        return this.$store.state.incidencias.providers.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    providersByPromoAndProf () {
      if (this.$store.state.incidencias.providersByPropDevAndProf) {
        return this.$store.state.incidencias.providersByPropDevAndProf.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    oficios () {
      if (this.$store.state.incidencias.oficios) {
        return this.$store.state.incidencias.oficios
      }
      return []
    },
    estados () {
      if (this.$store.state.incidencias.estados && this.$store.state.incidencias.estados.length > 0) {
        let estadosAux = []
        this.$store.state.incidencias.estados.forEach(estado => {
            estadosAux.push(estado)
        })
        return estadosAux.map(x => {
          return {
            ...x,
            text: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    responsables () {
      let responsables = []
      if (this.$store.state.incidencias.responsables) {
        responsables =  this.$store.state.incidencias.responsables.map(x => {
          return {
            ...x,
            name: x.nombre + ' ' + x.apellidos
          }
        })
        return responsables.sort(function (a, b) {
          if (a.name < b.name) { return -1 }
          if (a.name > b.name) { return 1 }
          return 0
        })
      }
      return []
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',
      getResponsables: 'incidencias/getResponsables'
    }),
    async untoggle () {
      await this.$nextTick()
      this.toggle = null
    },
    aplicarFiltros () {
      this.$emit('aplicar', this.objFiltrosParaApi)
    },
    borrarFiltros () {
      this.reiniciarFiltros()
      this.$emit('borrar', this.objFiltrosParaApi)
    },
    reiniciarFiltros () {
      this.promocion = []
      this.proveedor = []
      this.oficio = []
      this.estado = []
      this.responsable = []
      this.tipoDocumento = []
      this.fechaDesde = null
      this.fechaHasta = null
      this.revisada = false
    },
    mostrarPopupPromociones () {
      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
    },
    popupSeleccionarPromociones (promocionesSelected) {
      this.inmueble = null
      if (promocionesSelected != null && promocionesSelected.length > 0) {
        console.log("popupSeleccionarPromociones")
        console.log(promocionesSelected.map( x => x.id))
        this.promocion =  promocionesSelected.map( x => x.id)
      } else {
        this.promocion = []
      }

    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].toLowerCase()
        let y = b[field].toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    },
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma]
      } else {
        return item.name || item.description || item.text || ''
      }
    }
  },
  watch: {
    'promocion': function () {
      let items = {
        professionId: this.oficio,
        propertyDevelopmentId: ( this.promocion.length > 0 ? this.promocion : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
    },
    'oficio': function (){
      let items = {
        professionId: this.oficio == null ? null : this.oficio,
        propertyDevelopmentId: ( this.promocion.length > 0 ? this.promocion : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
    }
  }
}
</script>

<style scoped>

.botonAplicar {
  margin-left: 5px;
}
</style>
